import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GoogleMapsLoaderService {
  private isLoaded = false;
  private loadingPromise: Promise<void> | null = null;

  constructor() {}

  loadGoogleMaps(): Promise<void> {
    if (this.isLoaded) {
      return Promise.resolve();
    }

    if (this.loadingPromise === null) {
      this.loadingPromise = new Promise((resolve, reject) => {
        try {
          const apiKey = environment.googleMapsApiKey;
          const script = document.createElement('script');
          const urlParams = new URLSearchParams();

          urlParams.set('key', apiKey);
          urlParams.set('v', 'weekly');
          urlParams.set('callback', 'googleMapsCallback');
          urlParams.set('loading', 'async');

          script.src = `https://maps.googleapis.com/maps/api/js?${urlParams.toString()}`;

          document.head.appendChild(script);

          window['googleMapsCallback'] = () => {
            this.isLoaded = true;
            resolve();
          };

          script.onerror = () => reject(new Error('Google Maps API failed to load.'));
        } catch (error) {
          reject(error instanceof Error ? error : new Error('An unexpected error occurred.'));
        }
      });
    }

    return this.loadingPromise;
  }
}
